// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1CJBf","colCheckbox":"styles_colCheckbox__2ONKS"};